// Global open-state for `<ManipulationHowItWorksModal />`.
//
// The modal mounts once at the app-shell level. The "Preventing manipulation"
// cross-link inside the market detail and markets-feed how-it-works modals flips
// `open` to true (after closing its own parent), so a single mounted modal serves
// every surface.

'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

export interface ManipulationModalState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useManipulationModalStore: UseBoundStore<StoreApi<ManipulationModalState>> =
  createTrackedStore<ManipulationModalState>('useManipulationModalStore')((set) => ({
    open: false,
    setOpen: (open: boolean): void => set({ open }),
  }));
